module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sliderUpHideRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "lenovobox_audio_vedio_mask",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVideo),
      expression: "isShowVideo"
    }]
  }, [_c('video', {
    staticClass: "lenovobox_vedio",
    attrs: {
      "controls": "controls",
      "autoplay": "autoplay",
      "src": _vm.videoUrl,
      "name": "media",
      "id": "lenovobox_video_player",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoUrl,
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAudio),
      expression: "isShowAudio"
    }]
  }, [_c('audio', {
    staticClass: "lenovobox_audio",
    attrs: {
      "id": "lenovobox_audio_player",
      "src": _vm.audioUrl,
      "controls": "controls",
      "autoplay": "autoplay",
      "controlsList": "nodownload"
    }
  }, [_vm._v("\n        您的浏览器暂不支持播放该音频，请升级至最新版浏览器\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08740c2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/preview_audio_vedio.vue
// module id = 213
// module chunks = 3